import { computed } from 'vue'
import store from '@/store'
import { ApiServiceSettingsElCountriesData } from '@/apis/swaggers/v3/api/service-settings/service-settings-swagger'
import { useServiceSettingCountriesQuery } from '@/composables/queries/servicesetting/use-service-setting-countries-query'

type Country = NonNullable<ApiServiceSettingsElCountriesData['data']>[number]

export const KOREA_ISO2 = 'KR'
export const VIETNAM_ISO2 = 'VN'

/*
 * 국가 목록에서 ISO 3166-1 alpha-2 코드로 국가 _id 를 찾는다.
 * 환경별 MongoDB _id 하드코딩(구 constants/country.js)을 대체한다.
 *
 * - 부트스트랩(loadCountryList)과 동일한 파라미터를 사용해 같은 쿼리 캐시를 공유한다.
 * - 국가 목록은 사실상 불변이라 staleTime Infinity — 세션당 1회만 조회된다.
 * - 국가 목록 로드 전에는 id 가 undefined 다. (부트스트랩에서 선로드되므로 실사용 시점엔 채워져 있다)
 */
export function useCountryCodes() {
  const { data } = useServiceSettingCountriesQuery({
    params: () => ({
      hospitalID: store.state.hospital.selectedHospital?._id as string,
      limit: 240,
    }),
    options: () => ({ enabled: !!store.state.hospital.selectedHospital?._id }),
  })

  const countries = computed(() => (data.value ?? []) as Country[])
  // 서버가 _id 를 countryId 로 리네임해 내려준다 (el_find_countries.js)
  const findCountryIdByISO2 = (iso2: string) =>
    countries.value.find((c) => c.countryCodeISOAlpha2 === iso2)?.countryId

  const koreaCountryCodeId = computed(() => findCountryIdByISO2(KOREA_ISO2))
  const vietnamCountryCodeId = computed(() => findCountryIdByISO2(VIETNAM_ISO2))

  return { countries, koreaCountryCodeId, vietnamCountryCodeId }
}
